import dayjs from "dayjs";
import classNames from "classnames";

// Components
import PageTitle from "components/atoms/PageTitle";
import TournamentCard from "components/molecules/TournamentCard";

// Hooks
import useTranslate from "hooks/useTranslate";
import { useNavigate } from "react-router-dom";

// Types
import { TournamentDataType, TournamentStatus } from "types/Tournament";

import { useRouterHistoryStore } from "stores/routerHistory";

import "./styles.sass";
import useScrollDetection from "../../../../hooks/useScrollDetection";

type TournamentsPageProps = {
  tournaments: TournamentDataType[];
  isAuthenticated: boolean | null;
};

type FilteredTournamentsType = {
  activeTournaments: TournamentDataType[];
  endedTournaments: TournamentDataType[];
};

const TournamentsPage = (props: TournamentsPageProps) => {
  const { tournaments, isAuthenticated } = props;

  const t = useTranslate();
  const navigate = useNavigate();
  const isScrolled = useScrollDetection();

  const previousPage = useRouterHistoryStore((state) => state.previous);

  const { activeTournaments } = tournaments.reduce(
    (prev: FilteredTournamentsType, tournament: TournamentDataType) => {
      const isTournamentEnded = dayjs().isAfter(dayjs(tournament.endDate));
      if (isTournamentEnded) {
        if (prev.endedTournaments.length >= 3) {
          return prev;
        }
        return {
          ...prev,
          endedTournaments: [...prev.endedTournaments, tournament],
        };
      }
      return {
        ...prev,
        activeTournaments: [...prev.activeTournaments, tournament],
      };
    },
    {
      activeTournaments: [],
      endedTournaments: [],
    },
  );

  const TournamentHeader = classNames("TournamentsPage__header", {
    notAuth: !isAuthenticated,
    border: isScrolled,
  });

  const TournamentList = classNames("TournamentsPage__list", {
    notAuth: !isAuthenticated,
  });

  return (
    <div className="TournamentsPage">
      <div className={TournamentHeader}>
        <PageTitle
          title="tournament.page.title"
          onBack={() => navigate(previousPage)}
        />
      </div>

      {activeTournaments && !!activeTournaments.length && (
        <div className={TournamentList}>
          <div className="TournamentsPage__title">
            {t("tournament.page.title.active")}
          </div>

          <div className="TournamentsPage__grid">
            {activeTournaments.map((tournament) => (
              <TournamentCard
                tournament={{
                  ...tournament,
                  status: TournamentStatus.ACTIVE,
                  rules: "Rules not available",
                }}
                key={tournament.id}
              />
            ))}
          </div>
        </div>
      )}

      {/* {endedTournaments && !!endedTournaments.length && (
                <div className="TournamentsPage__list">
                    <div className="TournamentsPage__title">{t('tournament.page.finished')}</div>

                    <div className="TournamentsPage__grid">
                        {endedTournaments.map((tournament) => (
                            <TournamentCard tournament={tournament} key={tournament.id} finished />
                        ))}
                    </div>
                </div>
            )} */}
    </div>
  );
};

export default TournamentsPage;
